//dependencias
import React, { Component } from 'react';

//componentes
import EvaluacionDAction from './evaluacionD'

class Index extends Component {

    render(){
        return(
            <div>
                <EvaluacionDAction />
            </div>
        );
    }

}
export default Index;